import { render, staticRenderFns } from "./installServe.vue?vue&type=template&id=50ef35a3&scoped=true&"
import script from "./installServe.vue?vue&type=script&lang=js&"
export * from "./installServe.vue?vue&type=script&lang=js&"
import style0 from "./installServe.vue?vue&type=style&index=0&id=50ef35a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef35a3",
  null
  
)

export default component.exports